module.exports = __webpack_public_path__ + "images/ui/icon_ranking_leaf_gold_5fbca64928e8192e4760d52735aad200.svg";